import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import BlogList from "./pages/BlogList";
import BlogArticle from "./pages/BlogArticle";
import Signup from "./pages/Signup";
import Policy from "./pages/Policy";
import Login from "./pages/Login";
import MerchantDashboard from "./pages/MerchantDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/policies/:slug" element={<Policy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<MerchantDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
